import React from 'react';

import { useProfileData } from 'hooks';

import { BannerAlert, BannerInfo, BannerWarning, Container } from '../../../index';
import BannerBlock, { BannerBlockVariant } from './BannerBlock';

const AccountNotReadyWarningSection = () => {
  const profileData = useProfileData();

  const needIdentification = (): boolean => {
    return !profileData.lenderVerified && !profileData.hasIdentificationDraft;
  };
  const needContract = (): boolean => {
    return profileData.lenderVerified && profileData.agentCode === null;
  };

  const hasFirstDeposit = (): boolean => {
    return profileData.agentCode !== null && profileData.hasTransactions;
  };

  return (
    <>
      {(needIdentification() || needContract() || !hasFirstDeposit() || true) && (
        <div>
          <Container>
            {needIdentification() && (
              <BannerWarning>
                <BannerBlock variant={BannerBlockVariant.IDENTIFICATION} />
              </BannerWarning>
            )}
            {needContract() && (
              <BannerAlert>
                <BannerBlock variant={BannerBlockVariant.CONTRACT} />
              </BannerAlert>
            )}
            {!needIdentification() &&
              !hasFirstDeposit() &&
              !needContract() &&
              !profileData.lenderVerified && (
                <BannerWarning>
                  <BannerBlock variant={BannerBlockVariant.DEPOSIT} />
                </BannerWarning>
              )}
            {profileData.lenderVerified && !hasFirstDeposit() && !needContract() && (
              <BannerInfo>
                <BannerBlock variant={BannerBlockVariant.VERIFIED} />
              </BannerInfo>
            )}
          </Container>
        </div>
      )}
    </>
  );
};

export default AccountNotReadyWarningSection;
